export default {
  adapter: "saffron",
  maxFileSizeMB: 100, // megs
  saffron: {
    getTokenRelativeUrl: "media-manager/token/",
    uploadFilePath: "http://localhost:3001/api/files/",
    baseRelativeUrl: "media-manager",
  },
};
